export default "__VITE_ASSET__61be0ac4__"